var _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.72727C9 4.32561 9.32561 4 9.72727 4H11.9091C12.3108 4 12.6364 4.32561 12.6364 4.72727C12.6364 4.95174 12.9288 5.45455 13.7273 5.45455C14.5257 5.45455 14.8182 4.95174 14.8182 4.72727C14.8182 4.32561 15.1438 4 15.5455 4H17.7273C18.1289 4 18.4545 4.32561 18.4545 4.72727V15.6364C18.4545 16.038 18.1289 16.3636 17.7273 16.3636H15.5455C15.1438 16.3636 14.8182 16.038 14.8182 15.6364C14.8182 15.3808 14.5405 14.9091 13.7273 14.9091C13.3256 14.9091 13 14.5835 13 14.1818C13 13.7802 13.3256 13.4545 13.7273 13.4545C14.8195 13.4545 15.7896 14.025 16.1369 14.9091H17V5.45455H16.1296C15.7783 6.31297 14.8221 6.90909 13.7273 6.90909C12.6325 6.90909 11.6762 6.31297 11.325 5.45455H10.4545V9.81818C10.4545 10.2198 10.1289 10.5455 9.72727 10.5455C9.32561 10.5455 9 10.2198 9 9.81818V4.72727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7273 19.2727H11.5454C11.5454 18.5018 10.8182 17.8182 9.72726 17.8182C8.63636 17.8182 7.90908 18.5018 7.90908 19.2727H5.72726V8.36365H7.90908C7.90908 9.09092 8.63636 9.81819 9.72726 9.81819C10.8182 9.81819 11.5454 9.09092 11.5454 8.36365H13.7273V19.2727Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.36363C5 7.96196 5.32561 7.63635 5.72727 7.63635H7.90909C8.31075 7.63635 8.63636 7.96196 8.63636 8.36363C8.63636 8.5881 8.92881 9.0909 9.72727 9.0909C10.5257 9.0909 10.8182 8.5881 10.8182 8.36363C10.8182 7.96196 11.1438 7.63635 11.5455 7.63635H13.7273C14.1289 7.63635 14.4545 7.96196 14.4545 8.36363V19.2727C14.4545 19.6744 14.1289 20 13.7273 20H11.5455C11.1438 20 10.8182 19.6744 10.8182 19.2727C10.8182 19.0171 10.5405 18.5454 9.72727 18.5454C8.91407 18.5454 8.63636 19.0171 8.63636 19.2727C8.63636 19.6744 8.31075 20 7.90909 20H5.72727C5.32561 20 5 19.6744 5 19.2727V8.36363ZM6.45455 9.0909V18.5454H7.31768C7.66494 17.6613 8.63504 17.0909 9.72727 17.0909C10.8195 17.0909 11.7896 17.6613 12.1369 18.5454H13V9.0909H12.1296C11.7783 9.94932 10.8221 10.5454 9.72727 10.5454C8.63246 10.5454 7.67623 9.94932 7.32496 9.0909H6.45455Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9091 12.7273C8.31076 12.7273 8.63637 12.4016 8.63637 12C8.63637 11.5983 8.31076 11.2727 7.9091 11.2727C7.50743 11.2727 7.18182 11.5983 7.18182 12C7.18182 12.4016 7.50743 12.7273 7.9091 12.7273Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72727 12.7273C10.1289 12.7273 10.4545 12.4016 10.4545 12C10.4545 11.5983 10.1289 11.2727 9.72727 11.2727C9.32561 11.2727 9 11.5983 9 12C9 12.4016 9.32561 12.7273 9.72727 12.7273Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5454 12.7273C11.9471 12.7273 12.2727 12.4016 12.2727 12C12.2727 11.5983 11.9471 11.2727 11.5454 11.2727C11.1438 11.2727 10.8182 11.5983 10.8182 12C10.8182 12.4016 11.1438 12.7273 11.5454 12.7273Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81818 3.27271H20.2727V20.7273H2.81818V3.27271Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.cadcb781b0f5cb1b175e9439f4487da3.svg";
export { ForwardRef as ReactComponent };